import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-961c4f9a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "table table-sm text-nowrap align-middle mb-0 ps-2" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { colspan: "11" }
const _hoisted_6 = { class: "d-flex justify-content-center mt-20" }
const _hoisted_7 = {
  key: 0,
  class: "spinner-border text-primary",
  role: "status"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center text-black" }, "No companies found.", -1))
const _hoisted_12 = [
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CompanyModal = _resolveComponent("CompanyModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "table-responsive draggable-container",
          ref: "tableContainer",
          onMousedown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.startDragging && _ctx.startDragging(...args))),
          onMousemove: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.drag && _ctx.drag(...args))),
          onMouseup: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.stopDragging && _ctx.stopDragging(...args))),
          onMouseleave: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.stopDragging && _ctx.stopDragging(...args)))
        }, [
          _createElementVNode("table", _hoisted_3, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableConfig, (column) => {
                  return (_openBlock(), _createElementBlock("th", {
                    key: column.key,
                    scope: "col",
                    class: _normalizeClass(["text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0", column.class])
                  }, _toDisplayString(column.header), 3))
                }), 128))
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_ctx.companies.length)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.companies, (company) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: company.id,
                      class: _normalizeClass({ 'row-passed': company.status === 'Passed' && !_ctx.filtersApplied.includes('STATUS=PASD') })
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableConfig, (column) => {
                        return (_openBlock(), _createElementBlock("td", {
                          key: column.key,
                          class: _normalizeClass(["shadow-none lh-1 fw-medium", [column.cellClass, { 'row-passed': company.status === 'Passed' && !_ctx.filtersApplied.includes('STATUS=PASD') }, { 'text-black-emphasis': company.status !== 'Passed' }]])
                        }, [
                          (_openBlock(), _createBlock(_resolveDynamicComponent(column.component), _mergeProps({ ref_for: true }, { ...column.component === 'CompanyText' ? { text: company[column.key] } : { company: company }, key: column.key }, {
                            onCompanySelected: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectedCompany = $event)),
                            onCompanyCheckbox: _ctx.companyChecked,
                            onUpdateStatus: _ctx.updateStatus
                          }), null, 16, ["onCompanyCheckbox", "onUpdateStatus"]))
                        ], 2))
                      }), 128))
                    ], 2))
                  }), 128))
                : (_openBlock(), _createElementBlock("tr", _hoisted_4, [
                    _createElementVNode("td", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        (_ctx.loading)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
                          : (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
                      ])
                    ])
                  ]))
            ])
          ])
        ], 544)
      ])
    ]),
    _createVNode(_component_CompanyModal, { company: _ctx.selectedCompany }, null, 8, ["company"])
  ], 64))
}